(() => {
  const initialize = (scope = document) => {
    const toggle = scope.querySelector('[data-menu-toggle]');
    const menu = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    if (toggle && menu && typeof menu.showModal === 'function' && !toggle.dataset.initialized) {
      const fallback = toggle.closest('[data-header]')?.querySelector('[data-menu-fallback]');
      const focused = fallback?.contains(document.activeElement) ? document.activeElement : null;
      const wasOpen = !!fallback?.open && !window.matchMedia('(min-width: 981px)').matches;
      const close = () => {
        if (menu.open) menu.close();
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('jrg-menu-open');
      };
      const open = () => {
        menu.hidden = false;
        menu.showModal();
        toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('jrg-menu-open');
      };
      menu.querySelector('[data-menu-close]').addEventListener('click', () => { close(); toggle.focus({ preventScroll: true }); });
      menu.addEventListener('cancel', event => { event.preventDefault(); close(); toggle.focus({ preventScroll: true }); });
      menu.addEventListener('close', () => {
        // A close event may arrive after an immediate reopen; keep that new session intact.
        if (!menu.open) close();
      });
      menu.addEventListener('click', event => {
        if (event.target.closest('a')) close();
      });
      toggle.addEventListener('click', () => {
        if (menu.open) close(); else open();
      });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !menu.hidden) { close(); toggle.focus(); }
      });
      const desktopMedia = window.matchMedia('(min-width: 981px)');
      let mobileFocus;
      document.addEventListener('focusin', event => {
        mobileFocus = menu.contains(event.target) || event.target === toggle ? event.target : undefined;
      });
      document.addEventListener('pointerdown', event => {
        if (!menu.contains(event.target) && !toggle.contains(event.target)) mobileFocus = undefined;
      });
      window.addEventListener('blur', () => { mobileFocus = undefined; });
      desktopMedia.addEventListener('change', event => {
        if (!event.matches) { mobileFocus = undefined; return; }
        const focused = document.activeElement === document.body && mobileFocus ? mobileFocus : document.activeElement;
        mobileFocus = undefined;
        const restoreFocus = menu.contains(focused) || focused === toggle;
        const href = focused?.closest('a')?.getAttribute('href');
        const header = toggle.closest('[data-header]');
        close();
        if (restoreFocus) requestAnimationFrame(() => {
          // Let native dialog closure finish before moving desktop focus.
          const active = document.activeElement;
          if (!desktopMedia.matches || menu.open || (active !== document.body && active !== toggle && !menu.contains(active))) return;
          const visible = node => node && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
          const matching = href && [...header.querySelectorAll('.desktop-nav a')].find(link => link.getAttribute('href') === href);
          const summary = matching?.closest('details')?.querySelector('summary');
          const target = visible(matching) && !matching.closest('details:not([open])') ? matching : visible(summary) ? summary : header.querySelector('.brand-logo');
          if (visible(target)) target.focus({ preventScroll: true });
        });
      });
      // Replace the native control in one task without moving the page or losing focus.
      if (fallback) fallback.hidden = true;
      if (wasOpen) open();
      if (wasOpen) menu.scrollTop = fallback.querySelector('nav')?.scrollTop || 0;
      toggle.hidden = false;
      toggle.dataset.initialized = 'true';
      toggle.closest('[data-header]')?.setAttribute('data-menu-ready', 'true');
      if (focused) {
        const link = wasOpen && focused.closest('a');
        const replacement = link && [...menu.querySelectorAll('a')].find(node => node.getAttribute('href') === link.getAttribute('href'));
        (replacement || toggle).focus({ preventScroll: true });
      }
    }
    scope.querySelectorAll('[data-quantity-change]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const input = button.closest('.quantity-control').querySelector('input');
        const minimum = Number(input.min || 0);
        const maximum = input.max ? Number(input.max) : Infinity;
        const current = Number(input.value) || minimum;
        input.value = Math.max(minimum, Math.min(maximum, current + Number(button.dataset.quantityChange)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    scope.querySelectorAll('[data-product]').forEach(container => {
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';
      const select = container.querySelector('[data-variant-select]');
      const variants = JSON.parse(container.querySelector('[data-variants]').textContent);
      const words = JSON.parse(container.querySelector('[data-product-translations]').textContent);
      const image = container.querySelector('#ProductMainImage');
      const setImage = (url, alt) => {
        if (!image || !url) return;
        image.src = url;
        image.removeAttribute('srcset');
        if (alt) image.alt = alt;
        container.querySelectorAll('[data-product-image]').forEach(button => button.classList.toggle('is-active', button.dataset.productImage === url));
      };
      container.querySelectorAll('[data-product-image]').forEach(button => button.addEventListener('click', () => setImage(button.dataset.productImage, button.dataset.imageAlt)));
      if (select) select.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === select.value);
        if (!variant) return;
        container.querySelector('[data-product-price]').textContent = variant.price;
        const compare = container.querySelector('[data-product-compare]');
        compare.hidden = !variant.on_sale;
        compare.textContent = variant.compare;
        const button = container.querySelector('[data-add-to-cart]');
        button.disabled = !variant.available;
        button.firstChild.textContent = variant.available ? words.add : words.sold_out;
        setImage(variant.image);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      });
    });
    scope.querySelectorAll('.nav-dropdown').forEach(details => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) document.querySelectorAll('.nav-dropdown').forEach(other => { if (other !== details) other.open = false; });
      });
      details.addEventListener('keydown', event => { if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); } });
      document.addEventListener('click', event => { if (!details.contains(event.target)) details.open = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
